import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { PropTypes } from 'prop-types'
import { useTranslation } from 'react-i18next'
import UIButton from '../components/UI/UIButton'
import UIRadio from '../components/UI/UIRadio'
import { COLOR_BLACK, COLOR_WHITE } from '../lib/colors'
import { leToBr } from '../utils/Utils'
import { useQuery, useMutation } from '@apollo/client'
import GET_REPORT_REASONS from '../graphql/Reports/GetReportReasons'
import REPORT_MAKER from '../graphql/Reports/ReportMaker'
import { useForm, Controller } from 'react-hook-form'
import { toast } from 'react-toastify'

const ReportReason = ({ closeToast, endLive }) => {
  const { t } = useTranslation('translation')

  const { data: reasonList } = useQuery(GET_REPORT_REASONS)
  const [reportMaker, { loading: loadingReport }] = useMutation(REPORT_MAKER, {
    onCompleted: () => {
      closeToast()
      endLive()
    },
    onError: () => {
      toast.error(t('pages.live.reportFailedMessage'))
    },
  })

  const { control, handleSubmit } = useForm({
    mode: 'onSubmit',
  })

  const onSubmit = ({ reason }) => {
    const idRequest = localStorage.getItem('idRequest')
    if (!idRequest || !reason) {
      return
    }
    reportMaker({
      variables: { idWatcherAlertReason: reason, idRequest },
    })
  }

  return (
    <div className={css(styles.containerPopup)}>
      <p>{leToBr(t('pages.live.reportReasonTitle'))}</p>
      <div className={css(styles.reasonContainer)}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="reason"
            control={control}
            render={({ field }) => (
              <>
                {reasonList?.alertReasons?.nodes.length > 0 ? (
                  reasonList?.alertReasons?.nodes.map(({ id, name }, index) => (
                    <UIRadio
                      {...field}
                      key={index}
                      label={name}
                      value={id}
                      checked={field?.value === id}
                    />
                  ))
                ) : (
                  <p>{t('common.loading')}</p>
                )}
              </>
            )}
          />
          <div className={css(styles.containerButtonPopup)}>
            <UIButton
              design="invertedPrimary"
              label={t('common.button.cancel')}
              onClick={closeToast}
            />
            <UIButton
              type="submit"
              design="primary"
              label={t('pages.live.report')}
              disabled={loadingReport}
            />
          </div>
        </form>
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  containerPopup: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 700,
    fontSize: '1.2em',
    textAlign: 'center',
    color: COLOR_BLACK,
    backgroundColor: COLOR_WHITE,
    padding: '1.5em',
  },
  containerButtonPopup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2em',
    fontWeight: 700,
    color: COLOR_WHITE,
    marginTop: '0.5em',
  },
  reasonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
  },
})

ReportReason.propTypes = {
  closeToast: PropTypes.func,
  endLive: PropTypes.func,
}

export default ReportReason
